import { Button, Message, Modal, Spin } from "@arco-design/web-react";
import { ModalProps } from "@arco-design/web-react/es/Modal/modal";
import Nav from "../../CreativeSpace/Nav/ProjectNav";
import { IconPlus, IconRight } from "@arco-design/web-react/icon";
import EditInput from "./EditInput/EditInput";
import { useEffect, useState } from "react";
import useNavProject from "@/useStore/createspace/useProject";
import useRequest from "@/requestHooks/mixCutDetail/useRequest";
import { IMaterialDetail } from "@/services/createSpace/graphQ/getSimpleMedia";
import {
  IGetMaterialSearch,
  getMetarialData,
} from "@/services/createSpace/graphQ/getMetarialList";
import yellowFolderImg from "@/assets/create-space/folder-yellow.png";
import "./MoveMaterialModal.less";

interface IMoveModal extends Omit<ModalProps, "onOk"> {
  fileTitleName: "move" | "copy";
  onOk: (projectId: number, targetId: number) => void;
  isDisabled?: boolean;
  editIds: number[];
}

const toEditIdsGetFilterData = (ids: number[], data: any[]) => {
  return data.filter((item) => !ids.includes(item.id));
};

const MoveModal: React.FC<IMoveModal> = (props) => {
  const { fileTitleName, visible, onOk, editIds, ...rest } = props;
  const {
    projectId,
    projectList,
    handleModifyNavList,
    handleToIdDeleteNavItem,
    toKeyWordGetNavItem,
    handleDeleteProjectItem,
  } = useNavProject();
  const { loading, handleRequest, searchData } = useRequest<
    IMaterialDetail,
    IGetMaterialSearch
  >({
    request: getMetarialData,
    initSearchData: {
      parentId: 0,
      projectId: projectId,
      type: [4],
      keyword: "",
      sort_field: "",
    },
    manual: true,
    page: {
      page: 1,
      page_size: 100000,
    },
  });
  const [editState, setEditState] = useState(false);
  const [navProjectId, setNavProjectId] = useState(projectId);
  const [menuFristList, setMenuFristList] = useState<any[]>([]);
  const [menuSencondList, setMenuSencondList] = useState([]);
  const [menuThirdList, setMenuThirdList] = useState([]);
  const [secondLoading, setSecondLoading] = useState(false);
  const [thirdLoading, setThirdLoading] = useState(false);
  const [currentParentIdList, setCurrentParentIdList] = useState<number[]>([]);
  const handleChangeIndex = async (floor: number, id: number) => {
    const idList = [...currentParentIdList];
    if (floor === 0) {
      setSecondLoading(true);
      setMenuThirdList([]);
    } else if (floor === 1) {
      setThirdLoading(true);
    }
    if (floor === 2) {
      idList[2] = id;
      setCurrentParentIdList(idList);
      return;
    }
    try {
      const resultData = await handleRequest({
        ...searchData,
        parentId: id,
      });

      switch (floor) {
        case 0: {
          idList[0] = id;
          idList.splice(1);
          setMenuSencondList(toEditIdsGetFilterData(editIds, resultData.data));
          break;
        }
        case 1: {
          idList[1] = id;
          idList.splice(2);
          setMenuThirdList(toEditIdsGetFilterData(editIds, resultData.data));
          break;
        }
        default: {
          return;
        }
      }
      setCurrentParentIdList(idList);
    } finally {
      if (floor === 0) {
        setSecondLoading(false);
      } else if (floor === 1) {
        setThirdLoading(false);
      }
    }
  };

  const init = async () => {
    const result = await handleRequest({
      ...searchData,
      projectId: (projectList || [])[0]?.id,
    });
    console.log(editIds, 'editIds')
    setMenuFristList(toEditIdsGetFilterData(editIds, result.data));
    setNavProjectId(projectList[0].id);
  };

  const getCurrentParentId = () => {
    if (!currentParentIdList || currentParentIdList.length === 0) {
      return null;
    }
    return currentParentIdList[currentParentIdList.length - 1];
  };

  useEffect(() => {
    if (visible) {
      init();
    }
  }, [visible]);

  return (
    <>
      <Modal
        {...rest}
        visible={visible}
        style={{ ...rest.style, width: 760 }}
        onOk={() => {
          onOk(navProjectId, getCurrentParentId());
        }}
        className="space-file-transfer-modal-wrapper ">
        <div className="space-file-wrapper">
          <Nav
            style={{
              height: "100%",
              border: "1px solid #eee",
              borderRadius: "8 8 0 0",
              marginRight: 11,
            }}
            projectId={navProjectId}
            projectList={projectList}
            handleModifyNavList={handleModifyNavList}
            handleToIdDeleteNavItem={handleToIdDeleteNavItem}
            toKeyWordGetNavItem={toKeyWordGetNavItem}
            handleProjectIdChange={async (e) => {
              setNavProjectId(e);
              const result = await handleRequest({
                ...searchData,
                parentId: 0,
                projectId: e,
              });
              // setMenuFristList(result.data);
              setMenuFristList(toEditIdsGetFilterData(editIds, result.data));
              setMenuSencondList([]);
              setMenuThirdList([]);
              setCurrentParentIdList([]);
            }}
            handleProjectItemDelete={handleDeleteProjectItem}></Nav>
          <div className={"file-transfer"}>
            <div className="transfer-header">
              <div className="transfer-header-name">素材文件夹</div>
              {/* <Button
                icon={<IconPlus />}
                type="text"
                onClick={() => {
                  setEditState(true);
                }}>
                新建文件夹
              </Button> */}
            </div>
            {editState ? (
              <div className="file-menu-add-wrapper">
                <EditInput
                  onPressEnter={() => {
                    Message.success("添加成功！");
                    setEditState(false);
                  }}
                />
              </div>
            ) : (
              <div className="file-menu-wrapper">
                <ul>
                  <Spin loading={loading === "loading"}>
                    {(menuFristList || []).map((item, index) => {
                      return (
                        <li
                          onClick={() => {
                            handleChangeIndex(0, item.id);
                          }}
                          key={item.name}
                          className={`${currentParentIdList[0] === item.id ? "active" : ""}`}>
                          <img src={yellowFolderImg} className="folder-img" />
                          <span className="name">{item.name}</span>
                          <IconRight className="icon-next" />
                        </li>
                      );
                    })}
                  </Spin>
                </ul>
                <ul>
                  <Spin loading={secondLoading}>
                    {(menuSencondList || []).map((item, index) => {
                      return (
                        <li
                          key={item.name}
                          onClick={() => {
                            handleChangeIndex(1, item.id);
                          }}
                          className={`${currentParentIdList[1] === item.id ? "active" : ""}`}>
                          <img src={yellowFolderImg} className="folder-img" />
                          <span className="name">{item.name}</span>
                          <IconRight className="icon-next" />
                        </li>
                      );
                    })}
                  </Spin>
                </ul>
                <ul>
                  <Spin loading={thirdLoading}>
                    {menuThirdList.map((item, index) => {
                      return (
                        <li
                          key={item.name}
                          onClick={() => {
                            handleChangeIndex(2, item.id);
                          }}
                          className={`${currentParentIdList[2] === item.id ? "active" : ""}`}>
                          <img src={yellowFolderImg} className="folder-img" />
                          <span className="name">{item.name}</span>
                        </li>
                      );
                    })}
                  </Spin>
                </ul>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MoveModal;
